<template>
  <div class="research_group_container" :style="{'height': boxHeight}">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">订单详情</span>
    </div>
    <div v-show="order">
      <div class="bd" v-show="status===1">
        <div class="group_2">
          <span class="info" :lines="undefined">下单成员：{{order.orderPerson}}</span>
          <span class="price" :lines="undefined">单笔订单限额：
          <span v-if="memberInfo.approveThreshold!==undefined">￥{{splitMoney(memberInfo.approveThreshold)}}</span>
          <span v-else>无</span>
        </span>
        </div>
        <div class="container_2">
          <div class="priceWrap">
            <span class="info_2" :lines="undefined">本月累计消费 ：</span>
            <span class="price_2" :lines="undefined">¥{{splitMoney(monthlyTotalApprovedAmount)}}</span>
          </div>
          <span class="money" :lines="undefined">单月累计限额：
          <span v-if="memberInfo.monthlyLimit!==undefined">￥{{splitMoney(memberInfo.monthlyLimit)}}</span>
          <span v-else>无</span>
        </span>
        </div>
      </div>
      <div class="box" :style="{'margin-top': orderAddress}">
        <div class="submain"  v-show="order.expressAddress!==''&&order.expressAddress!==undefined">
          <div style="line-height: 15.2vw;margin-left: 4vw;">
            <svg width="12px" height="17px" viewBox="0 0 12 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
              <title>形状</title>
              <desc>Created with Sketch.</desc>
              <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="执行中订单详情" transform="translate(-25.000000, -118.000000)" fill="#5878FA" fill-rule="nonzero">
                  <g id="地点" transform="translate(25.000000, 118.000000)">
                    <path d="M5.99998382,0 C2.68650826,0 0,2.76794957 0,6.18183182 C0,11.2045379 5.99998382,17 5.99998382,17 C5.99998382,17 12,11.2045712 12,6.18183182 C12,2.76794957 9.31350792,0 5.99998382,0 Z M5.99998382,9.27270606 C4.34252624,9.27270606 3,7.88874794 3,6.18181515 C3,4.47488236 4.34251007,3.09090758 5.99998382,3.09090758 C7.65676205,3.09090758 8.99998382,4.47488236 8.99998382,6.18181515 C8.99998382,7.88873128 7.6567297,9.27270606 5.99998382,9.27270606 Z" id="形状"></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>

          <div class="address_area" >
            <span class="phonePrev" :lines="undefined">{{order.expressAddress}}</span>
            <span class="luWei" :lines="undefined">{{order.expressName}}&nbsp;&nbsp;{{order.expressMobile}}</span>
          </div>
        </div>
        <div class="row">
          <div class="block_4">
          <span class="orderNumber" :lines="undefined"
          >订单编号：{{order.orderNo}}</span
          >
            <div class="tagWrap">
              <span class="tag" id="tag-copy" :data-clipboard-text="order.orderNo" :lines="undefined" @click="copy">复制</span>
            </div>
          </div>
          <div class="div" />
          <div style="padding-left: 4vw;padding-right: 4vw;width: 100%;" >
            <!--商品信息-->
            <div v-for="(item,i) in order.itemList" style="padding-top: 10px;">
              <div class="block-item" style="height: 52px;" v-if="order.fromEmkt">
                <div class="block-address">
                  <img v-if="item.merchandiseIcon"
                       class="largeIcon"
                       :src=baseurl+item.merchandiseIcon
                  />
                  <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                       class="largeIcon"
                       :src=baseurl+emkt.CUSTOMIZE_IMAGE
                  />
                  <img v-else class="largeIcon" :src=serviceUrl />
                  <div class="item-detail" v-if="item.categoryId">
                <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;" v-if="item._titleList && item._titleList.length > 0" >
                   <span v-for="title in item._titleList">
                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>&nbsp;</span>
                  </span>
                </span>
                    <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._subTitleList && item._subTitleList.length > 0" >
                  <span v-for="(subTitle, index) in item._subTitleList">
                    <span v-if="index !== 0">/</span>
                    <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{subTitle.valueText}}</span>
                  </span>
                </span>
                    <span class="light-text-color tiny-font text-overflow-hidden" v-if="item._abstractList && item._abstractList.length>0">
                   <span v-for="(abstractTitle, index) in item._abstractList">
                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' "><span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span>&nbsp;</span>
                   </span>
                </span>
                  </div>
                  <div class="item-detail" v-else>
                <span class="deep-text-color" style="font-size: 12px;">
                   {{item.name}}
                </span>
                    <span class="light-text-color small-font">
                  <span>
                    {{ stringSet(item.serviceItemDetail.productInfoList[0])}}
                  </span>
                </span>
                    <span class="light-text-color small-font">
                   <span>
                     {{item.serviceItemDetail.productInfoList[1]}}
                   </span>
                </span>
                  </div>
                </div>
                <span class="light-text-color">X {{item.quantity}}</span>
              </div>
              <div class="block-item" style="height: 52px;" v-else-if="item.productType === emkt.PRODUCT_TYPE_TOOL">
                <div class="block-address">
                  <img v-if="item.merchandiseIcon"
                       class="largeIcon"
                       :src=baseurl+item.merchandiseIcon
                  />
                  <img v-else-if="item.categoryId === 20 || item.categoryId === 10"
                       class="largeIcon"
                       :src=baseurl+emkt.CUSTOMIZE_IMAGE
                  />
                  <div class="item-detail">
                    <span class="deep-text-color text-overflow-hidden" style="font-size: 12px;">{{item.name}}</span>
                    <span class="light-text-color tiny-font text-overflow-hidden">{{item.TLNo}} {{item.tag1PUBID}} {{item.eu_RID}}</span>
                    <span class="light-text-color tiny-font text-overflow-hidden" v-if="item.tax">{{item.tax}} <span v-if="item.symbol">{{item.symbol}}</span></span>
                  </div>
                </div>
                <span class="light-text-color">X {{item.quantity}}</span>
              </div>
              <div class="block-item" style="height: 80px;" v-else-if="(item.productType !== emkt.PRODUCT_TYPE_TOOL)&&(item.contractNoSrc===''||item.contractNoSrc===undefined)">
                <div class="tabbarserviceselWrap">
                  <img
                    class="iconTest"
                    src="static/img/service_product.png"
                  />
                </div>
                <div class="item-detail">
                  <span class="deep-text-color" style="font-size: 12px;">{{item.name}}</span>
                </div>
              </div>
              <div class="priceWrap_2" v-if="item.productType==='服务类'">
                <div class="tagWrap_2"  v-if="showProductDetailBtn(item) && item.name !== '实物返还' && isService" @click="toProductInfo(item.orderId, item.serviceItemDetail.euId)">
                  <span class="tag_2" :lines="undefined">产品详情</span>
                </div>
                <div v-show="status===2" @click="toProgress(item)" :class="[item.orderId!==undefined?'tagWrap_3':'tagWrap_2']">
                  <span :class="[item.orderId!==undefined?'tag_3':'tag_2']">进展查询</span>
                </div>
                <span class="price_3" :lines="undefined">￥{{splitMoney(item.price)}}</span>
              </div>
              <div class="priceWrap_2" v-if="item.productType==='产品类'">
                <div class="tagWrap_2" v-show="item.orderId!==undefined" @click="toProductInfo(item.orderId)">
                  <span class="tag_2" :lines="undefined">产品详情</span>
                </div>
                <div v-show="status===2" @click="toProgress(item)" :class="[item.orderId!==undefined?'tagWrap_3':'tagWrap_2']">
                  <span :class="[item.orderId!==undefined?'tag_3':'tag_2']">进展查询</span>
                </div>
                <span class="price_3" :lines="undefined">￥{{splitMoney(item.price)}}</span>
              </div>
              <div class="split-line" />
            </div>
            <!--<div v-for="(item,i) in order.itemList" v-if="item.productType==='产品类'||((item.productType==='服务类'||item.productType==='非消费合同-常规预收')&&(item.contractNoSrc===''||item.contractNoSrc===undefined))">-->
              <!--<div class="group_3">-->
                <!--<img v-if="item.merchandiseIcon"-->
                     <!--class="largeIcon"-->
                     <!--:src=baseurl+item.merchandiseIcon-->
                <!--/>-->
                <!--<img v-else-->
                     <!--class="largeIcon"-->
                     <!--src="static/img/show_product.png"-->
                <!--/>-->
                <!--<div class="outer_2" v-if="item.productType==='产品类'">-->
                  <!--<span class="lentivirus" :lines="undefined">{{item.name}} <span class="gfpPuromycin" :lines="undefined" >{{item.TLNo}} {{item.tag1PUBID}} {{item.eu_RID}}</span></span>-->
                  <!--<span class="humanatgnm" :lines="undefined" v-show="item.tax!==''&&item.tax!==undefined"-->
                  <!--&gt;{{item.tax}}<span v-show="item.symbol!==''&&item.symbol!==undefined">/{{item.symbol}}/{{item.nm_ID}}</span></span-->
                  <!--&gt;-->
                <!--</div>-->
                <!--<div class="outer_2" v-if="item.productType==='服务类'||item.productType==='非消费合同-常规预收'||item.productType==='其他（不计任务）'">-->
                  <!--<span class="info_name" style="left: -18.73vw;" :lines="undefined">{{item.name}}</span>-->
                <!--</div>-->
                <!--<span class="txt" :lines="undefined"  v-if="item.productType==='产品类'">X {{item.quantity}}</span>-->
              <!--</div>-->
              <!--<div class="priceWrap_2" v-if="item.productType==='服务类'">-->
                <!--<div v-show="status===2" @click="toProgress(item)" class="tagWrap_2">-->
                  <!--<span class="tag_2" :lines="undefined" >进展查询</span>-->
                  <!--<span class="price_3" :lines="undefined">￥{{splitMoney(item.price)}}</span>-->
                <!--</div>-->
                <!--&lt;!&ndash;              <span class="price_3" :lines="undefined">￥{{item.price}}</span>&ndash;&gt;-->
              <!--</div>-->
              <!--<div class="priceWrap_2" v-if="item.productType==='产品类'">-->
                <!--<div class="tagWrap_2" v-show="item.orderId!==undefined" @click="toProductInfo(item.orderId)">-->
                  <!--&lt;!&ndash;              <div class="tagWrap_2" @click="toProductInfo(item.orderId)">&ndash;&gt;-->
                  <!--<span class="tag_2" :lines="undefined">产品详情</span>-->
                <!--</div>-->
                <!--<div v-show="status===2" @click="toProgress(item)" :class="[item.orderId!==undefined?'tagWrap_3':'tagWrap_2']">-->
                  <!--<span :class="[item.orderId!==undefined?'tag_3':'tag_2']">进展查询</span>-->
                <!--</div>-->
                <!--<span class="price_3" :lines="undefined">￥{{splitMoney(item.price)}}</span>-->
              <!--</div>-->

              <!--<div class="div" />-->
            <!--</div>-->
          </div>
          <div class="moneyWrap_2">
            <span class="totalMerchandise" :lines="undefined">商品总额</span>
            <span class="money_3" :lines="undefined">￥{{splitMoney(order.initPrice)}}</span>
          </div>
          <div class="container_4" >
            <span class="discount" :lines="undefined">优惠折扣</span>
            <span class="price_5" :lines="undefined">-￥{{discountPrice}}</span>
          </div>
          <div class="moneyWrap_3" v-show="order.expressPrice">
            <span class="freight" :lines="undefined">运费</span>
            <span class="money_4" :lines="undefined">￥{{order.expressPrice}}</span>
          </div>
          <div class="empty" />
          <div class="group_5">
            <span class="totalGoods" :lines="undefined">共{{itemListLength}}件商品</span>
            <div class="moneyWrap_4">
              <span class="total" :lines="undefined">合计</span>
              <span class="money_5" :lines="undefined">￥{{splitMoney(order.price)}}</span>
            </div>
          </div>
        </div>
      </div>

    <div :style="{'padding-bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
      <div class="row_area">
        <div class="row0">
          <span class="paymentMethod" :lines="undefined">支付方式</span>
          <span class="info_4" :lines="undefined">{{displayChosenResearchGroup.researchGroupName}}结算</span>
        </div>
        <div class="row1">
          <span class="orderTime" :lines="undefined">下单时间</span>
          <span class="word" :lines="undefined">{{order.orderTime}}</span>
        </div>
      </div>
    </div>

      <div class="footer">
      <div class="block_6" v-show="status===1" >
        <div class="tagWrap_5" @click="toggleResearchGroupDisagreeBox()" v-if="order.fromEmkt">
          <span class="tag_5" :lines="undefined" >不同意</span>
        </div>
        <div class="tagWrap_6" @click="agree()" v-if="order.fromEmkt">
          <span class="tag_6" :lines="undefined" >同意</span>
        </div>
        <span class="customerService" :lines="undefined" @click="goMessage">客服</span>
        <div style="position: absolute;left: 7vw;top: 0.67vh;" @click="goMessage">
          <svg width="20px" height="23px" viewBox="0 0 20 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>服务评价-客服</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="待审批-订单详情" transform="translate(-26.000000, -862.000000)" fill="#4191EA" fill-rule="nonzero">
                <g id="编组-6" transform="translate(0.000000, 849.000000)">
                  <g id="编组" transform="translate(26.000000, 13.000000)">
                    <g id="服务评价-客服" transform="translate(0.000000, 0.000000)">
                      <path d="M19.0783731,12.6660875 L19.0783731,12.0399707 C19.1274803,9.1794763 18.2877472,6.7732235 16.6328345,5.0667483 C15.8422086,4.25156878 14.8895289,3.63772878 13.7846169,3.21049614 C13.607831,1.66853006 11.9529184,0.450671497 9.93461243,0.450671497 C7.91630651,0.450671497 6.24666171,1.6660747 6.08460795,3.21049614 C4.97969595,3.63772878 4.02701627,4.25156878 3.23639035,5.0667483 C1.58147771,6.7732235 0.739289234,9.1671995 0.790851794,12.0276939 L0.790851794,12.7937662 C0.363619154,13.2332757 0.0247794743,13.8839461 0.277681554,14.8120721 C0.466744274,15.5020283 0.967637714,16.0029217 1.58147771,16.2288149 C1.89576379,16.4301544 2.25915707,16.5431009 2.65938075,16.5431009 C3.45000667,20.0051585 6.29576891,22.3623041 10.0230054,22.3623041 C13.7477865,22.3623041 16.5960041,20.0051585 17.38663,16.5308241 C17.4111836,16.5308241 17.4357372,16.5431009 17.4627462,16.5431009 C17.9513628,16.5431009 18.4031491,16.366315 18.7665424,16.0790379 C19.2306054,15.8163144 19.5939987,15.3645281 19.7437756,14.7997953 C20.0064992,13.7930977 19.5669897,13.1031416 19.0783731,12.6660875 Z M16.895558,14.5591701 C16.895558,15.0232331 16.8587276,15.4627425 16.7948883,15.8875198 C15.5794851,17.8444417 13.5710006,19.1236843 11.0763548,19.3986846 C10.8872921,19.1482379 10.511622,18.9837288 10.0721126,18.9837288 C9.44599579,18.9837288 8.94264699,19.3225685 8.94264699,19.7498011 C8.94264699,20.1647569 9.44354043,20.5158734 10.0721126,20.5158734 C10.6368454,20.5158734 11.0886316,20.2408731 11.1893014,19.8750245 C11.9922041,19.7866315 12.7582764,19.5877473 13.485063,19.2980149 C14.5138588,18.883059 15.4174313,18.269219 16.1810483,17.4908699 C16.3062716,17.3656465 16.4192182,17.2404232 16.5321648,17.102923 C15.6285923,19.8774798 13.2076073,21.6576158 10.0598358,21.6576158 L10.0352822,21.6576158 C5.98393819,21.6576158 3.16272955,18.7357374 3.16272955,14.5591701 L3.15045275,14.1589464 C3.15045275,13.9821605 3.17500635,13.5058206 3.19955995,13.0540344 C4.88148155,12.4401944 6.39889403,10.0928702 7.01273403,9.01496718 C7.57746683,9.7810395 8.86898619,11.2591662 10.8504617,12.0252385 C11.5895251,12.3125157 12.3433206,12.464748 13.082384,12.6268017 C14.5506892,12.9410878 15.9428784,13.2406417 16.8832812,14.4707771 L16.9201116,14.5076075 L16.895558,14.5591701 L16.895558,14.5591701 Z" id="形状"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <footer-placeholder></footer-placeholder>
      </div>

      <ResearchGroupDisagreeBox v-if="showResearchGroupDisagreeBox" @toggleShow="toggleResearchGroupDisagreeBox" @confirm="disagree"/>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import ResearchGroupDisagreeBox from '../researchGroupComponents/ResearchGroupDisagreeBox'
  import Clipboard from 'clipboard'
  import {mapGetters, mapMutations, mapState} from 'vuex'
  import EMKT from '../../../../emkt'
  import FooterPlaceholder from '../../../../views_v_2.6/components/FooterPlaceholder'
  export default {
    name: 'OrderDetailInfo',
    data () {
      return {
        status: 2,
        memberInfo: {},
        order: {},
        showResearchGroupDisagreeBox: false,
        monthlyTotalApprovedAmount: 0,
        orderList: {},
        baseurl: '/emktResources/resocurces/img/merchandise/',
        serviceUrl: '/emktResources/resocurces/img/merchandise/service.png',
        orderNo: this.$route.query.orderNo || EMKT.getFullUrlParam('orderNo'),
        researchGroupNo: this.$route.query.researchGroupNo || EMKT.getFullUrlParam('researchGroupNo'),
        routeType: this.$route.query.routeType - 0,
        isWapp: EMKT.isWapp,
        isService: null
      }
    },
    created () {
      if (this.chosenOrder.itemList[0].serviceItemDetail) {
        this.isService = true
      } else {
        this.isService = false
      }
    },
    watch: {
      'researchGroupDetailList': {
        handler: 'setResearchGroupByGroupNo',
        immediate: true
      }
    },
    components: {
      ResearchGroupDisagreeBox, FooterPlaceholder
    },
    mounted () {
      if (this.routeType === 1) {
        this.fetchWaitApproveOrderDetail()
      }
    },
    computed: {
      ...mapGetters([
        'displayChosenResearchGroup', 'chosenOrder', 'totalApproveAmount', 'chosenMember', 'hasLogin', 'researchGroupCharacter', 'researchGroupDetailList'
      ]),
      ...mapState([
        'researchGroupMemberMap', 'chosenMember'
      ]),
      // 计算属性的 getter
      boxHeight: function () {
        if (this.status === 1) {
          return '90vh'
        } else {
          return '97vh'
        }
      },
      itemListLength () {
        let num = 0
        if (this.order.itemList) {
          for (let i = 0; i < this.order.itemList.length; i++) {
            let item = this.order.itemList[i]
            if (item.productType === '服务类') {
              if (item.contractNoSrc === '') {
                num++
              }
            } else {
              num++
            }
          }
        }
        return num
      },
      // 混合服务类合同名称位置
      namePos: function () {
        if (this.orderType !== 2) {
          return '-20vw'
        } else {
          return '-6.73vw'
        }
      },
      // 订单地址位置
      orderAddress: function () {
        if (this.status === 1) {
          return '20vw'
        } else {
          return '2.67vw'
        }
      },
      // 商品总额
      discountPrice: function () {
        if (this.order) {
          let discountPrice = (this.order.discountPrice + '').replace('-', '') - 0
          return discountPrice
        } else {
          return 0
        }
      },
      memberList () {
        if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return
        if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return
        const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
        return this.researchGroupMemberMap[researchGroupNo]
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_RESEARCHGROUP_ORDER_MAP', 'UPDATE_CHOSEN_ORDER', 'UPDATE_CHOSEN_MEMBER', 'UPDATE_TOTAL_APPROVE_AMOUNT', 'UPDATE_CHOSEN_RESEARCH_INDEX'
      ]),
      setResearchGroupByGroupNo () {
        console.log('researchGroupDetailList', this.researchGroupDetailList)
        if (!this.hasLogin) {
          $.toast('请登录')
          this.$router.push({name: 'login'})
        }
        if (!this.researchGroupNo) return
        let researchGroupIndex = 0
        for (let i = 0; i < this.researchGroupDetailList.length; i++) {
          if (this.researchGroupDetailList[i].researchGroupNo === this.researchGroupNo) {
            researchGroupIndex = i
            continue
          }
        }
        this.UPDATE_CHOSEN_RESEARCH_INDEX(researchGroupIndex)
        if (this.researchGroupCharacter === 'leader' || this.researchGroupCharacter === 'approver') {
          this.fetchWaitApproveOrderDetail()
        }
      },
      fetchWaitApproveOrderDetail: function () {
        if (this.routeType === 1) {
          // 订单列表跳转
          this.order = this.chosenOrder
          this.orderList = EMKT.getLocalStorage('ResearchGroupOrderList')
          this.status = this.$route.query.status - 0
          this.memberInfo = this.chosenMember
          this.monthlyTotalApprovedAmount = this.totalApproveAmount
        } else {
          if (this.researchGroupNo && this.orderNo) {
            this.$weui.loading('查询中')
            // 获取订单详情
            this.gcapi('getWaitApprovedOrderInfoByOrderNo', this.order.id).then(res => {
              if (res.data.code === 0) {
                this.order = res.data.result
                this.UPDATE_CHOSEN_ORDER(res.data.result)
                console.log('审批提醒查到的订单信息', res.data)
                EMKT.setLocalStorage('ResearchGroupOrder', this.order)
                if (this.order.status === 13) {
                  this.status = 1
                  var memberInfo = {}
                  for (let i = 0; i < this.memberList.length; i++) {
                    if (res.data.result.orderPerson === this.memberList[i].memberName) {
                      memberInfo = this.memberList[i]
                      break
                    }
                  }
                  this.memberInfo = memberInfo
                  this.UPDATE_CHOSEN_MEMBER(memberInfo)
                  console.log('下单成员信息', memberInfo)
                  this.gcapi('getMonthlyTotalApprovedAmount', this.order.id).then(res => {
                    console.log('月度累计限额：', res.data)
                    if (res.data.code === 0) {
                      this.monthlyTotalApprovedAmount = res.data.result
                      this.UPDATE_TOTAL_APPROVE_AMOUNT(this.monthlyTotalApprovedAmount)
                    } else {
                      console.log('获取月度累计限额失败')
                    }
                  })
                  this.$weui.loading().hide()
                } else {
                  this.status = 2
                  this.$weui.loading().hide()
                  return this.$weui.toast('此订单已完成审批')
                }
              } else {
                this.$weui.loading().hide()
                console.log('获取课题组订单信息失败')
              }
            })
          }

          // 微信审批提醒跳转
          const queryParam = {}
          queryParam.researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
          this.gcapi('getAllOrdersByCustomerNoOrResearchGroupNo', queryParam).then(res => {
            console.log('课题组订单信息：', res.data.result)
            if (res.data.code === 0) {
              this.orderList = res.data.result
              EMKT.setLocalStorage('ResearchGroupOrderList', this.orderList)
            } else {
              console.log('获取课题组订单列表信息失败')
            }
          })
        }
      },
      goBack: function () {
        this.$router.push({name: 'ResearchGroupOrder', query: {index: this.tabIndex}})
      },
      toProgress: function (item) {
        EMKT.setLocalStorage('chosenItem', JSON.stringify(item))
        this.$router.push({name: 'Progress', query: {item: JSON.stringify(item)}})
      },
      toProductInfo: function (orderId, euId) {
        if (this.isService) {
          if (orderId && euId) {
            this.$router.push({
              name: 'boSolutionDetail',
              params: {orderId: orderId, euId: euId}
            })
          } else {
            alert('产品数据错误，请刷新页面后重试！')
          }
        } else {
          if (orderId) {
            this.gcapi('assambleOrders', orderId).then(res => {
              console.log('产品详情', res.data)
              this.$router.push({name: 'FinderMerchandiseDetailForGR', params: {merchandises: res.body.result.merchandises[0]}, query: {orderStatus: this.status, routeType: this.routeType}})
            })
          }
        }
      },
      toggleResearchGroupDisagreeBox () {
        this.showResearchGroupDisagreeBox = !this.showResearchGroupDisagreeBox
      },
      agree () {
        console.log('order->', this.order)
        const approveParams = {
          orderNo: this.order.orderNo,
          orderId: this.order.id,
          isApproved: true
        }
        this.$weui.loading('保存中')
        this.gcapi('approveResearchGroupOrder', approveParams).then(res => {
          this.$weui.loading().hide()
          if (res && res.body.code === 0) {
            this.removeOrder(this.order.orderNo)
            this.goBack()
          } else {
            this.$weui.toast('保存失败')
          }
        })
      },
      disagree (reason) {
        console.log('reason', reason)
        if (!reason) return this.$weui.toast('请填写原因')
        const approveParams = {
          orderNo: this.order.orderNo,
          orderId: this.order.id,
          isApproved: false,
          remark: reason
        }
        this.$weui.loading('保存中')
        this.gcapi('approveResearchGroupOrder', approveParams).then(res => {
          this.$weui.loading().hide()
          if (res && res.body.code === 0) {
            this.removeOrder(this.orderNo)
            this.goBack()
          } else {
            this.$weui.toast('保存失败')
          }
        })
      },
      removeOrder (orderNo) {
        console.log('开始去除订单。。')
        for (var i = 0; i < this.orderList.waitApprovedOrderList.length; i++) {
          let worder = this.orderList.waitApprovedOrderList
          if (worder[i].orderNo === orderNo) {
            this.orderList.waitApprovedOrderList.splice(i, 1)
          }
        }
        console.log('审批后订单', this.orderList)
      },
      copy () {
        const clipboard = new Clipboard('#tag-copy')
          // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
        clipboard.on('success', e => {
          $.toast('复制成功')
          clipboard.destroy() // 释放内存
        })
        clipboard.on('error', e => {
          $.toast('该浏览器不支持自动复制')
          clipboard.destroy()
        })
      },
      splitMoney (moneyNumber) {
        if (moneyNumber === undefined) {
          return ''
        }
        return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
      },
      goMessage () {
        EMKT.openCustomerService()
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      },
      stringSet (str) {
        if (str) {
          let temp = str.replace(/&nbsp;/gi, ' ')
          return temp
        } else {
          return ''
        }
      },
      showProductDetailBtn (item) {
        if (!item) return false
        return item.fromEmkt
      }
    }
  }
</script>

<style scoped>
  .text-overflow-hidden {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 75%;
  }
  .deep-text-color {
    color: #424242;
    font-size: 12px;
    /*font-weight: 500;*/
    font-weight: bold;
  }
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .block-item {
    height: 35px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .split-line {
    border-top: .7px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }

  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height: 92vh;
  }

  .navshare {
    position: absolute;
    left: 6.67vw;
    color:#ffffff;
    line-height: 4.93vw;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }
  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }

  .box {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100vw;
    top: 14.93vw;
    bottom: 4vw;
  }

  .icon {
    margin-right: 1.33vw;
    width: 4.53vw;
    height: 2.67vw;
  }

  .bd {
    display: flex;
    position: fixed;
    align-items: flex-start;
    flex-direction: column;
    background-color: #ffffff;
    width: 100vw;
    height: 16.8vw;
    top:15vw;
    bottom: 20vw;
    z-index: 100;
  }

  .group_2 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 3.2vw;
    margin-left: 9.33vw;
    width: 77.33vw;
    height: 5.33vw;
  }

  .info {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .price {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .container_2 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    width: 79.47vw;
    height: 5.33vw;
  }

  .priceWrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.33vw;
  }

  .info_2 {
    opacity: 1;
    max-width: 25.87vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: pre;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .price_2 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ff9400;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .money {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .submain {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    height: 15.2vw;
  }
  .info_name {
    position: absolute;
    top: 2.4vw;
    left: -5.73vw;
    opacity: 1;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    line-height: 5.33vw;
    /*white-space: nowrap;*/
    display: inline-block;
    width: 63.2vw;
  }
  .address_area {
    position: relative;
    margin-top: 1.33vw;
    margin-left: 4vw;
    width: 80.2vw;
    height: 14.53vw;
  }

  .phonePrev {
    position: relative;
    display: inline-block;
    opacity: 1;
    margin-top: 2.67vw;
    line-height: 4.33vw;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    width: 83.2vw;
    height: 6vw;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
  }


  .luWei {
    position: absolute;
    top: 7.47vw;
    left: -0.13vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .row {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    margin-left: 0.67vw;
    padding-bottom: 3.73vw;
  }

  .block_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.13vw;
    width: 86.67vw;
    height: 6.13vw;
  }

  .orderNumber {
    opacity: 1;
    max-width: 72.27vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .tagWrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(151, 151, 151, 1);
    padding-right: 2.4vw;
    padding-left: 2.4vw;
    height: 6.13vw;
  }

  .tag {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .div {
    position: relative;
    margin-top: 1.6vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.67vw;
    height: 0.27vw;
  }

  .group_3 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.93vw;
    height: 13.87vw;
  }

  .gfpPuromycin {
    top: 2.4vw;
    left: 21.07vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;

  }

  .outer_2 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    width: 48.8vw;
    height: 13.87vw;
  }

  .lentivirus {
    position: absolute;
    top: 2.4vw;
    left: -5.73vw;
    opacity: 1;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    display: inline-block;
    width: 63.2vw;
  }

  .largeIcon {
    position: relative;
    margin-right: 1.33vw;
    width: 13.87vw;
    height: 13.87vw;
  }

  .humanatgnm {
    position: relative;
    opacity: 1;
    margin-top: 6.93vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
    left: -5.73vw;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 70.2vw;
    height: 6vw;
  }

  .txt {
    position: relative;
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 2.67vw;
    font-weight: 400;
  }
  .price {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .block_9 {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 4vw;
    margin-left: 4vw;
    height: 12.53vw;
  }

  .tabbarserviceselWrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 2.4vw;
    width: 12.53vw;
    height: 12.53vw;
  }

  .iconTest {
    position: absolute;
    top: 0;
    left: 0;
    width: 12.53vw;
    height: 12.53vw;
    overflow: hidden;
  }


  .info_7 {
    opacity: 1;
    margin-top: 1.33vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: 500;
  }

  .priceWrap_2 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: flex-end;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    margin-left: 19vw;
    width: 71.73vw;
    height: 6.93vw;
    margin-bottom: 10px;
  }

  .tagWrap_2 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(88, 120, 250, 1);
    padding-right: 3.47vw;
    padding-left: 3.2vw;
    height: 6.13vw;
  }

  .tag_2 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .empty_2 {
    position: relative;
    margin-top: 3.2vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }
  .tagWrap_3 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(88, 120, 250, 1);
    padding-right: 3.47vw;
    padding-left: 3.2vw;
    height: 6.13vw;
    left: 23vw;
    position: absolute;
  }

  .tag_3 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
  .price_3 {
    opacity: 1;
    margin-top: 1.6vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
    position: absolute;
    right: 4vw;
  }


  .moneyWrap_2 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.67vw;
    height: 5.87vw;
  }

  .totalMerchandise {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .money_3 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .container_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1.33vw;
    width: 86.67vw;
    height: 5.87vw;
  }

  .discount {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .price_5 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .moneyWrap_3 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1.33vw;
    width: 86.67vw;
    height: 5.87vw;
  }

  .freight {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .money_4 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .empty {
    position: relative;
    margin-top: 2.13vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.67vw;
    height: 0.27vw;
  }

  .group_5 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 3.2vw;
    width: 86.67vw;
    height: 5.6vw;
  }

  .totalGoods {
    opacity: 1;
    max-width: 64.8vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .moneyWrap_4 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 5.6vw;
  }

  .total {
    opacity: 1;
    max-width: 13.87vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #979797;
    font-size: 2.67vw;
    font-weight: 400;
  }

  .money_5 {
    opacity: 1;
    max-width: 34.4vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.73vw;
    font-weight: 500;
  }
  .row_area {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #efeef3;
    width: 100vw;
    height: 20vh;
    top: 14.93vw;
    bottom: 4vw;
  }
  .row0 {
    box-sizing: border-box;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    padding-right: 4vw;
    padding-left: 3.73vw;
    width: 94.67vw;
    height: 13.33vw;
  }

  .paymentMethod {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .info_4 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .row1 {
    box-sizing: border-box;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    top: 5.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    padding-right: 4vw;
    padding-left: 3.73vw;
    width: 94.67vw;
    height: 13.33vw;
  }

  .orderTime {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .word {
    opacity: 1;
    line-height: 5.33vw;
    white-space: pre;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .row2 {
    position: relative;
    margin-top: 2.4vw;
    border-top-width: 0.5px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 100vw;
    height: 0.27vw;
  }

  .ft {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;
    margin-top: 9.6vw;
    background-color: #ffffff;
    width: 100vw;
    height: 13.33vw;
  }

  .color_2 {
    margin-top: 9.87vw;
    border-radius: 0.53vw;
    background-color: #000000;
    width: 35.73vw;
    height: 1.33vw;
  }

  .block_6 {
    display: flex;
    position: relative;
    bottom: 0vw;
    align-items: flex-end;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 100vw;
    height: 13.33vw;
    padding-bottom: 1vh;
  }

  .tagWrap_5 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 2.67vw;
    margin-left: 17.33vw;
    border-radius: 4.53vw;
    background-color: #fe654d;
    padding-right: 13.87vw;
    padding-left: 13.6vw;
    height: 9.07vw;
  }

  .tag_5 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .tagWrap_6 {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 4.53vw;
    background-color: #5878fa;
    padding-right: 15.73vw;
    padding-left: 15.47vw;
    height: 9.07vw;
  }

  .tag_6 {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 3.73vw;
    font-weight: 400;
  }

  .customerService {
    position: absolute;
    bottom: 0.8vw;
    left: 6.93vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 2.67vw;
    font-weight: 400;
  }

  .icon_7 {
    position: absolute;
    bottom: 13.87vw;
    left: 6.93vw;
    width: 5.07vw;
    height: 5.6vw;
  }

  .footer {
  position: fixed;
  bottom:0;
  left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #fff;
 }

</style>



// WEBPACK FOOTER //
// OrderDetailInfo.vue?09929ffb